import React, { FC } from "react";
import { ReportItemsSearchPanel, ReportPage } from "../../../components";
import { getPageNameByPageId, getUserId } from "../../../utils";
import { ItemReportSearchParamsModel, PageEnum } from "../../../models";
import { searchReportInventoryCheckIn } from "../../../serviceBroker/itemsReportApiServiceBroker";

export const ReportInventoryCheckingPage: FC = () => {
    const initialState: ItemReportSearchParamsModel = { Lang: 1, userId: getUserId() };
    return (
        <ReportPage
            InitialState={initialState}
            SearchApi={searchReportInventoryCheckIn}
            searchHeader={getPageNameByPageId(PageEnum.ReportInventoryCheck)}
            SearchPanel={ReportItemsSearchPanel}
            withDateRange={true}
            formId={PageEnum.ReportInventoryCheck}
        />
    );
};
